import firebase from 'firebase';
import 'firebase/firestore';

import _ from 'lodash';

import { FIREBASE_CONFIG } from '../config';
import { convertDocument } from './helper';

export const firebaseApp = firebase.initializeApp(FIREBASE_CONFIG);
export const firebaseAuth = firebaseApp.auth();
export const firestore = firebase.firestore();
export const firebaseStorage = firebaseApp.storage ? firebaseApp.storage() : () => 1;

// const buildUser = (userInfo) => {
//   return firestore.doc(`users/${userInfo.uid}`).get().then(convertDocument)
//     .then((u) => {
//       if (!u) {
//         throw new Error('No accounts are associated with this user');
//       }
//       return u;
//     })
//     .then((u) => {
//       return Promise.all(_.keys(u.tenants).map((tenantId) => {
//         return Promise.all([
//           firestore.doc(`tenants/${tenantId}`).get().then(convertDocument),
//           firestore.doc(`tenants/${tenantId}/employees/${userInfo.uid}`).get().then(convertDocument),
//         ])
//           .then(([tenant, employee]) => {
//             u.tenants[tenantId] = tenant;
//             u.tenants[tenantId].employee = employee;
//             return u;
//           });
//       })).then(() => {
//         return u;
//       });
//     })
//     .then((u) => _.assign({}, _.pick(userInfo, ['uid']), _.pick(u, ['tenants'])))
//     .then((ui) => {
//       // if (typeof localStorage !== 'undefined') {
//         localStorage.setItem('userInfo', JSON.stringify(ui));
//         localStorage.setItem('tenants', JSON.stringify(ui.tenants));
//       // }
//       return ui;
//     });
// };

/**
 * upload employee image.
 *
 * @param path {!string|string}
 * @returns {!firebase image url|firebase image url}
 */
const uploadImage = (uploadPath, filename, file) => {
  const storageRef = firebaseStorage.ref(uploadPath).child(filename);
  const uploadFile = storageRef.put(file);
  return new Promise((resolve, reject) => {
    uploadFile.on('state_changed', () => {}, (error) => {
      console.error('Unable to upload customer image', error);
      reject(error);
    }, () => {
      // Handle successful uploads on complete
      // For instance, get the download URL: https://firebasestorage.googleapis.com/...
      const downloadURL = uploadFile.snapshot.downloadURL;
      console.log('download url:' , downloadURL);
      resolve(downloadURL);
    });
  });
};


const FireBaseTools = {

  /**
   * Return an instance of a firebase auth provider based on the provider string.
   *
   * @param provider
   * @returns {firebase.auth.AuthProvider}
   */
  getProvider: (provider) => {
    switch (provider) {
      case 'email':
        return new firebase.auth.EmailAuthProvider();
      default:
        throw new Error('Provider is not supported!!!');
    }
  },

  /**
   * Login with provider => p is provider "email", "facebook", "github", "google", or "twitter"
   * Uses Popup therefore provider must be an OAuth provider. EmailAuthProvider will throw an error
   *
   * @returns {any|!firebase.Thenable.<*>|firebase.Thenable<any>}
   */
  loginWithProvider: (p) => {
    const provider = FireBaseTools.getProvider(p);
    return firebaseAuth.signInWithPopup(provider).then(firebaseAuth.currentUser).catch((error) => ({
      errorCode: error.code,
      errorMessage: error.message,
    }));
  },

  /**
   * Log the user in using email and password
   *
   * @param user
   * @returns {any|!firebase.Thenable.<*>|firebase.Thenable<any>}
   */
  loginUser: (user, isScript) => {
    return firebaseAuth.signInWithEmailAndPassword(user.email, user.password)
      .then((userInfo) => {
        // console.log('userInfo', userInfo);
        return userInfo;
      })
      // .then(buildUser)
      // .then((user) => {
      //   return user;
      //   })
      // .then((userInfo) => firebaseDb.ref(`/users/${userInfo.uid}/tenantId`).once('value')
      //   .then((tenantId) => tenantId.data()).then((tenantId) => {
      //     return firebaseDb.ref(`/tenants/${tenantId}/info`).once('value')
      //       .then((snap) => snap.data()).then((tenantInfo) => {
      //         if (!isScript) {
      //           localStorage.setItem('tenantId', tenantId);
      //           localStorage.setItem('tenant', JSON.stringify(_.assign({ id: tenantId }, tenantInfo)));
      //         }
      //         return userInfo;
      //       });
      //   }))
      .catch((error) => {
        console.error('Login User', error);
        throw new Error({
          code: error.code,
          message: error.message || error,
        });
        // throw error;
      });
  },
  /**
   * Register a user with email and password
   *
   * @param user
   * @returns {any|!firebase.Thenable.<*>|firebase.Thenable<any>}
   */
  registerUser: (user) => firebaseAuth.createUserWithEmailAndPassword(user.email, user.password)
    .then((userInfo) => userInfo),

  /**
   * Sign the user out
   *
   * @returns {!firebase.Promise.<*>|firebase.Thenable<any>|firebase.Promise<any>|!firebase.Thenable.<*>}
   */
  logoutUser: () => firebaseAuth.signOut().then(() => {
    console.log('clearing local storage');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('tenant');
  }).then(() => ({
    success: 1,
    message: 'logout',
  })),

  // /**
  //  * Retrieve the current user (Promise)
  //  * @returns {Promise}
  //  */
  fetchUser: () => new Promise((resolve, reject) => {
    const unsub = firebaseAuth.onAuthStateChanged((user) => {
      unsub();
      if (!user) {
        return reject('User is not logged in');
      }
      return resolve(user);
    }, (error) => {
      reject(error);
    });
  }),
    // .then(buildUser),

  /**
   * Update a user's profile data
   *
   * @param u
   * @returns {!firebase.Promise.<*>|firebase.Thenable<any>|firebase.Promise<any>|!firebase.Thenable.<*>}
   */
  updateUserProfile: (u) => firebaseAuth.currentUser.updateProfile(u).then(() => firebaseAuth.currentUser, (error) => ({
    errorCode: error.code,
    errorMessage: error.message,
  })),

  /**
   * Update a user's email address
   *
   * @param email
   * @returns {!firebase.Promise.<*>|firebase.Thenable<any>|firebase.Promise<any>|!firebase.Thenable.<*>}
   */
  updateUserEmail: (email) => firebaseAuth.currentUser.updateEmail(email).then(() => firebaseAuth.currentUser)
    .catch((error) => {
      console.error('===========email update error==========>', error.message);
      return ({
        errorCode: error.code,
        errorMessage: error.message,
      });
    }),

  /**
   * Reset the password given the specified email
   *
   * @param email {string}
   * @returns {!firebase.Promise.<*>|firebase.Thenable<any>|firebase.Promise<any>|!firebase.Thenable.<*>}
   */
  resetPasswordEmail: (email) => firebaseAuth.sendPasswordResetEmail(email).then(() => ({
    message: 'Email sent',
  })),

  /**
   * Update the user's password with the given password
   *
   * @param newPassword {string}
   * @returns {!firebase.Promise.<*>|firebase.Thenable<any>|firebase.Promise<any>|!firebase.Thenable.<*>}
   */
  changePassword: (newPassword) => firebaseAuth.currentUser.updatePassword(newPassword)
    .then((user) => user),

  /**
   * Send an account email verification message for the currently logged in user
   *
   * @returns {!firebase.Promise.<*>|firebase.Thenable<any>|firebase.Promise<any>|!firebase.Thenable.<*>}
   */
  sendEmailVerification: (user) => {
    return Promise.resolve(1)
      .then(() => {
        if (user) {
          return firebaseAuth.signInWithEmailAndPassword(user.email, user.password)
            .then((u) => u.sendEmailVerification())
            .then(() => firebaseAuth.signOut());
        } else if (firebaseAuth.currentUser) {
          return firebaseAuth.currentUser.sendEmailVerification()
            .then(firebaseAuth.signOut);
        } else {
          return Promise.reject({
            message: 'User is not logged in',
          });
        }
      })
      .then(() => ({
        message: 'Email sent',
      }));

    // if (firebaseAuth.currentUser) {
    //   return firebaseAuth.currentUser.sendEmailVerification().then(() => ({
    //       message: 'Email sent',
    //     })
    //   );
    // } else {
    //   return Promise.reject({
    //     message: 'User is not logged in',
    //   });
    // }
  },

  // /**
  //  * Get the firebase database reference.
  //  *
  //  * @param path {!string|string}
  //  * @returns {!firebase.database.Reference|firebase.database.Reference}
  //  */
  // getDatabaseReference: (path) => firebaseDb.ref(path),

  /**
   * upload employee image.
   *
   * @param path {!string|string}
   * @returns {!firebase image url|firebase image url}
   */
  uploadEmployeeImage: (filename, file) => {
    return uploadImage(getTenantPath('employees'), filename, file);
  },

  /**
   * upload employee image.
   *
   * @param path {!string|string}
   * @returns {!firebase image url|firebase image url}
   */
  uploadCustomerImage: (filename, file) => {
    return uploadImage(getTenantPath('customers'), filename, file);
  },

  verifyPasswordResetCode: (code) => firebase.auth().verifyPasswordResetCode(code)
    .then((email) => email),
  setNewPassword: (code, newPassword) => firebase.auth().confirmPasswordReset(code, newPassword)
    .then(() => 'success'),
  applyVerificationCode: (code) => firebase.auth().applyActionCode(code)
    .then(() => 'success'),
};

function getTenantId() {
  const tenant = JSON.parse(localStorage.getItem('tenant'));
  return tenant ? tenant.id : null;
}

function getTenantPath(path) {
  const tenantId = getTenantId();
  const p = `/tenants/${tenantId}${!path.startsWith('/') ? '/' : ''}${path}`;
  return p;
}

function getIdToken() {
  console.log('getIdToken', firebase.auth().currentUser);
  if (firebase.auth().currentUser) {
    return firebase.auth().currentUser.getIdToken()
      .then((token) => {
        console.log('get current user token', token);
        return token;
      });
  }

  return Promise.reject('no auth token');

  // const token = localStorage.getItem('id_token');
  // return Promise.resolve(token);
}

export {
  FireBaseTools as default,
  getTenantPath,
  getTenantId,
  getIdToken,
};



// WEBPACK FOOTER //
// ./src/utils/firebase.js